module.exports = __webpack_public_path__ + "static/media/default.75b9dbbe.jpg";